// extracted by mini-css-extract-plugin
export default {"iconsContainer":"Ok9qZIS0","desktop":"desktop","mobile":"mobile","icon":"VDXTeSap"};